import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
// import { loginSaga } from './saga';
import { LoginState } from './types';
import { endpoints, formatErrors, baseQuery } from 'utils/api/endpoints';
import {
	LoginRequest,
	LoginData,
	ForgotPasswordRequest,
	AuthMessageData,
} from 'types/Auth';
import { ApiResponse } from 'types/ApiResponse';
// import { Login } from 'types/Login';
export const initialState: LoginState = {
	loading: false,
	error: null,
	user: null,
	isLoggedIn: false,
};

// export const slice = createSlice({
//   name: 'login',
//   initialState,
//   reducers: {
//     doLogin(state, action: PayloadAction<any>) {
//       state.loading = true;
//     },
//     loginSuccess(state, action: PayloadAction<any>) {
//       state.loading = false;
//       state.user = action.payload.user;
//       state.isLoggedIn = true;
//     },
//     loginError(state, action: PayloadAction<any>) {
//       state.loading = false;
//       state.error = action.payload.error;
//     },
//   },
// });
// export const { actions: loginActions } = slice;

export const api = createApi({
	reducerPath: 'loginApi',
	baseQuery,
	tagTypes: ['Auth'],
	endpoints: build => ({
		// Authentication endpoints
		login: build.mutation<ApiResponse<LoginData>, LoginRequest>({
			query: (loginData) => ({
				url: endpoints.login.url,
				method: endpoints.login.method,
				body: loginData,
			}),
			transformErrorResponse(baseQueryReturnValue, meta, arg) {
				return formatErrors(baseQueryReturnValue.data);
			},
		}),
		forgotPassword: build.mutation<ApiResponse<AuthMessageData>, ForgotPasswordRequest>({
			query: (emailData) => ({
				url: endpoints.forgotPassword.url,
				method: endpoints.forgotPassword.method,
				body: emailData,
			}),
			transformErrorResponse(baseQueryReturnValue, meta, arg) {
				return formatErrors(baseQueryReturnValue.data);
			},
		}),
	}),
});

export const useLoginSlice = () => {
	useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
	return {
		// Authentication mutations for Login page
		useLoginMutation: api.useLoginMutation,
		useForgotPasswordMutation: api.useForgotPasswordMutation,
	};
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useLoginSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
